/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { generateEmptyApi, MoreInfoParams } from '@environment';
import { Movie } from '@usheru-hff/shared/domain';
import { getDateFromDDMMYYYY } from '@usheru-hff/shared/utils';

import { carouselTypeParams } from './commons/carousel-type-params';
import { movieCrewConfig } from './commons/movie-crew-config';
import { AcontraEnvironment } from './acontra-environment';
import { AconFooterComponent } from '../app/footer/acon-footer.component';

export const environment: AcontraEnvironment = {
  api: generateEmptyApi(),
  appType: 'cdp',
  siteName: 'A Contracorriente Films',
  movieSiteFooterComponent: AconFooterComponent,
  movieSiteConfig: {
    'the-chosen-last-supper': {
      landingSection: {
        hideLogo: true,
        mediaPosition: 'top'
      }
    },
    'the-chosen-1': {
      landingSection: {
        hideLogo: true,
        hideTitleText: true
      },
      conversionHideTitleText: true,
      conversionHideTitleLogo: true
    }
  },
  movieAwarenessOriginalFooter: true,
  components: {
    aconFooter: {
      generalitatLogoMovieSlugs: [
        'out-of-control-8',
        'loveable',
        'not-without-my-shrink',
        'louise-violet',
        '-2054',
        'diamonds-8',
        'the-return-33',
        'ma-mere-dieu-et-sylvie-vartan',
        'how-to-make-a-killing',
        'julia-s',
        'rust-9',
        'sketch-4',
        'bob-trevino-likes-it'
      ]
    },
    header: {
      communityActivityAccordion: {
        disableAccordionBehavior: true,
        isInitiallyOpen: true
      }
    },
    channelVideo: {
      hideBackgroundImageOnVideo: true
    },
    movieDetailInfo: {
      showReleaseDate: (infoParams?: MoreInfoParams, movie?: Movie) =>
        !!infoParams &&
        infoParams?.releaseDate !== false &&
        !movie?.locReleaseDate &&
        !(movie?.releaseDate || infoParams?.releaseDateEmptyMessage),
      showLocReleaseDate: (infoParams?: MoreInfoParams, movie?: Movie) =>
        infoParams?.locReleaseDate !== false && !!(movie?.locReleaseDate || infoParams?.releaseDateEmptyMessage),
      showStreamingDate: () => false,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      showLocStreamingDate: () => false,
      enabledRedirections: () => ['genres']
    }
  },
  customPageParams: {
    favicon:
      'https://s3-eu-west-1.amazonaws.com/static.usheru.com/img/channels/acontracorriente.usheru.com/favicon/android-icon-144x144.png',
    headerFixed: true,
    headerSocialLinks: true,
    headerSearchActive: true,
    headerSMsearchCollapse: true,
    headerSMsearchActive: true,
    footerSocialLinks: true,
    channelVideoEmbed: true,
    movieDetailVideoEmbed: false,
    movieDetailContentAlternative: true,
    moviesCardsOnlyOneSide: true,
    movieDetailShowRightOwners: true,
    login: 'popup'
  },
  customFeatures: {
    // nonPrefixedMovieDetailRoutes: true
  },

  moreInfoParams: {
    releaseDate: false,
    locReleaseDate: 'full'
  },

  showStreamingTitleAlways: true,
  //
  carouselTypeParams: carouselTypeParams,
  movieCrew: movieCrewConfig,
  locReleaseDateMoviesSortInCinemas: movies =>
    movies.sort((a, b) => {
      const dateA = getDateFromDDMMYYYY(a.locReleaseDate);
      const dateB = getDateFromDDMMYYYY(b.locReleaseDate);
      return dateA > dateB ? 1 : dateA > dateB ? -1 : 0;
    }),
  customResponsive: {
    carouselMoviePortrait: {
      sizes:
        '(max-width: 576px) 90vw, (max-width: 768px) 50vw, (max-width: 1200px) 30vw, (max-width: 1400px) 16vw, 13vw',
      objectFit: 'cover',
      height: 'auto'
    }
  },
  communityConfig: {
    role: 'film-interactions',
    collectionsConfig: {
      collectionCategoryTitle: false,
      collectionImage: false,
      collectionsMovieSorting: ['title', 'releaseDate']
    },
    filmInteractionsConfig: {
      watchedIcon: 'eye'
    },
    profileConfig: {
      displayName: false,
      avatar: false,
      privacy: false,
      rating: false,
      savedSections: {
        hashtags: false,
        platforms: false
      }
    },
    userChipCompacted: true,
    hideCarouselsonHome: true
  },
  placeholderData: {
    // socialFeed: true
    // movie: 'clifford-the-big-red-dog'
    //   movies: true,
    //   performancesGroup: true,
    //   streamingLinks: true
    // tagsTypes: true,
    // tags: true
  }
};
